import { apiClient } from './apiClient';

// API Response Types
interface APIResponse<T> {
  success: boolean;
  data?: T;
  error?: {
    type: string;
    message: string;
    details: any;
  };
}

// Chatbot Request Types
export interface ChatbotMessageRequest {
  message: string;
  conversation_id?: string;
}

// Chatbot Response Types
export interface ChatbotMessageResponse {
  response: string;
  conversation_id: string;
  timestamp: string;
}

// Chatbot API
export const chatbotAPI = {
  /**
   * Send a message to the chatbot and receive a response.
   * 
   * @param message - The user's message/question
   * @param conversationId - Optional conversation ID for maintaining context
   * @returns Promise with chatbot response
   */
  sendMessage: async (
    message: string,
    conversationId?: string
  ): Promise<ChatbotMessageResponse> => {
    const requestData: ChatbotMessageRequest = {
      message,
      ...(conversationId && { conversation_id: conversationId }),
    };

    const response = await apiClient.post<APIResponse<ChatbotMessageResponse>>(
      '/chatbot/message/',
      requestData
    );

    if (!response.data.success || !response.data.data) {
      throw new Error(
        response.data.error?.message || 'Failed to get chatbot response'
      );
    }

    return response.data.data;
  },
};

export default chatbotAPI;

